import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useUserLocation } from '../../hooks';
import { MaintenanceNoticeModal, ScrollToTop, UserLocationSettings } from '../../components';
import { AppDataContext } from '../../context';
import type { UserMetaDataResponse } from '../../types';

const IndexView = () => {
  const [userHasRegisteredLocation, setUserHasRegisteredLocation] = useState<boolean>(true);

  const { authenticatedUser } = useContext(AppDataContext);
  const { handleCheckIfUserHasRegisteredLocation } = useUserLocation({ authenticatedUser });

  useEffect(() => {
    if (localStorage.getItem('locationDataRegistered') === 'true') {
      return;
    }

    handleCheckIfUserHasRegisteredLocation((response: UserMetaDataResponse) => {
      if (response?.country) {
        localStorage.setItem('locationDataRegistered', 'true');
      } else {
        setUserHasRegisteredLocation(false);
      }
    });
  }, []);

  return (
    <>
      <MaintenanceNoticeModal />
      <ScrollToTop />
      <UserLocationSettings
        userHasRegisteredLocation={userHasRegisteredLocation}
        setUserHasRegisteredLocation={setUserHasRegisteredLocation}
        authenticatedUser={authenticatedUser}
      />
      <Outlet />
    </>
  );
};

export default IndexView;
